import React, { useState, useEffect } from 'react';

interface Product {
    description: string;
    link: string;
    src:string;
}
const products:Product[] = [
    {
        description:"Vending Machine,Smart Refrigerated Vending Machine with Touch Card Reader US360 (Black, Mini)",
        link:'https://amzn.to/3XqMnNt',
        src:'https://m.media-amazon.com/images/I/61jUpk4CkuL._SL1201_.jpg'
    },
       {
        description:"HAHA Single-Layer Beverage Pusher for Vending Machines, Durable Plastic Construction, Smooth Dispensing for Bottled and Canned Drinks, Easy Installation, Lightweight and Reliable (VM-360)",
        link:'https://amzn.to/49NMPgb',
        src:'https://m.media-amazon.com/images/I/71D1+Ala4UL._SL1500_.jpg'
    },
       {
        description:"Amazon Basics Collapsible Folding Heavy Duty Utility Wagon for Outdoor Sports, 265 pounds Weight Capacity, Camping, Garden, and Shopping, 27.6 x 40.9 x 20 inches, Red",
        link:'https://amzn.to/3M66MFb',
        src:'https://m.media-amazon.com/images/I/81dQsugDlEL._AC_SL1500_.jpg'
    }
]
const FloatingSidebarAd = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Make sticky after scrolling 300px
      setIsSticky(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <>
      {/* Demo Content */}
 
            {/* Main Article */}
         
            {/* Sidebar with Floating Ad */}
            <aside className="lg:col-span-4">
              <div className={`transition-all duration-300 ${
                isSticky ? 'lg:sticky lg:top-20' : ''
              }`}>
                {/* Floating Ad Widget */}
                <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-slate-200">
                  {/* Close Button */}
                  <button
                    onClick={() => setIsVisible(false)}
                    className="absolute top-2 right-2 z-10 bg-slate-800 bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-1 transition-all"
                    aria-label="Close ad"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>

                  {/* Ad Label */}
                  <div className="bg-slate-100 px-3 py-1 text-xs text-slate-500 font-medium">
                    ADVERTISEMENT (affiliate link)
                  </div>

                  {/* Ad Content Area */}
                  <div className="gap-[25px] p-4 flex flex-col sm:flex-row  justify-between">
                      {products.map(product => {
                        return (
                       
                            <div className="flex-1 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-6 border-2 border-dashed border-blue-300 min-h-[250px] flex flex-col items-center justify-center text-center">
                            
                             <a href={product.link} target="_blank" className="flex flex-col items-center cursor-pointer">
                            <p className="font-bold">{product.description}</p>
                            <br/>
                            <img className="w-[50%]  mt-5" src={product.src}/>
                              </a>
                            </div>
                      
                        )
                      })}
                  </div>
                </div>

              </div>
            </aside>
    

      {/* Show Ad Button (after closing) */}
      {!isVisible && (
        <button
          onClick={() => setIsVisible(true)}
          className="fixed bottom-4 right-4 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow-lg text-sm font-medium transition-all z-50"
        >
          Show Ad
        </button>
      )}
    </>
  );
};

export default FloatingSidebarAd;